import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { TextMarkStruct } from '@/types/text-mark';

export interface ITextArtConfig {
    useBlackText?: number;
}

export interface ITextMarkModel {
    textLayerId: string;
    setTextLayerId: (payload: string) => void;
    markConfig: TextMarkStruct | null;
    setMarkConfig: (payload: TextMarkStruct | null) => void;
    textArtConfig: ITextArtConfig | null;
    setTextArtConfig: (payload: ITextArtConfig | null) => void;
}

/** 管理文字标记和艺术字面板状态 */
export const useTextMarkModel = create<ITextMarkModel>()(
    immer((set) => ({
        textLayerId: '',
        setTextLayerId: (payload) =>
            set((state) => {
                state.textLayerId = payload;
            }),
        markConfig: null,
        setMarkConfig: (payload) =>
            set((state) => {
                state.markConfig = payload;
            }),
        textArtConfig: null,
        setTextArtConfig: (payload) =>
            set((state) => {
                state.textArtConfig = payload;
            }),
    })),
);

/**
 * 获取文字标记状态
 *
 * @returns 当前文字标记 Store 状态
 */
export const getTextMarkModel = () => useTextMarkModel.getState();
